import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeTwoIconsSection = props => {
	const createMarkup = data => {
		return {
			__html: data,
		};
	};
	const isBiaggini = props.operator && props.operator.operator_name === 'biaggini';

	return (
		props.operator && props.operator.operator_name === "buseslafit" ? (
			<div className={`themes-theme-two-icons-section new-container lafitsmallicons`}
				style={{ gap: props.operator.operator_name === 'santarosa' ? '80px' : '' }}>
				{getIconsAndTexts(props.operator).map((val, index) => {
					return (
						<div className={`icon-section-item`} key={index}>

							<div className="left">
								<img src={val.icon} alt="" className="image" />
							</div>

							<div className="right">
								<div
									className={`title bold-text`}

									style={{
										color:
											props.operator &&
											props.operator.color_codes &&
											props.operator.color_codes.primary_text_color &&
											props.operator.color_codes.primary_text_color,
									}}
								>
									{val.title}
								</div>
								<div
									className={`desc normal-text`}

									style={{
										color:
											props.operator &&
											props.operator.color_codes &&
											props.operator.color_codes.tertiary_text_color &&
											props.operator.color_codes.tertiary_text_color,
										fontWeight: props.operator.operator_name === 'barriaghisoni' ? 'bold' : '',
									}}
								>
									{val.desc}

								</div>
							</div>
						</div>
					);
				})}
			</div>) : (<div className={`themes-theme-two-icons-section new-container`}
				style={{ gap: props.operator.operator_name === 'santarosa' ? '80px' : '' }}>
				{getIconsAndTexts(props.operator).map((val, index) => {
					return (
						<div className={`icon-section-item`} key={index}>

							<div className="left">
								<img src={val.icon} alt="" className="image" />
							</div>

							<div className="right">
								<div
									className={`title bold-text`}

									style={{
										color:
											props.operator &&
											props.operator.color_codes &&
											props.operator.color_codes.primary_text_color &&
											props.operator.color_codes.primary_text_color,
									}}
								>
									{val.title}
								</div>
								<div
									className={`desc normal-text`}

									style={{
										color:
											props.operator &&
											props.operator.color_codes &&
											props.operator.color_codes.tertiary_text_color &&
											props.operator.color_codes.tertiary_text_color,
										fontWeight: props.operator.operator_name === 'barriaghisoni' ? 'bold' : '',
									}}
								>
									{val.desc}

								</div>
							</div>
						</div>
					);
				})}
			</div>
		)



	);
};

const getIconsAndTexts = operator => {
	if (operator && operator.operator_name === 'barriaghisoni') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja cómodamente con nuestros asientos clásicos desde o hacia Argentina.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Entretención a bordo',
				desc: 'Aprovecha las comodidades que tenemos para ofrecer con TV durante tu viaje.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje impreso',
				desc: 'Asegúrate de mostrar tu pasaje impreso al momento de abordar el bus.',
			},
		];
	} else if (operator && operator.operator_name === 'combarbala') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja en nuestros asientos Semi Cama y Salón Cama hacia la Región de Coquimbo.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Comodidad garantizada',
				desc: 'La mejor experiencia a bordo con snacks, frazadas y sistema de climatización.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje impreso',
				desc: 'Asegúrate de mostrar tu pasaje impreso al momento de abordar el bus.',
			},
		]
	} else if (operator && operator.operator_name === 'expresosantacruz') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja en nuestros asientos Semi Cama y Salón Cama hacia Santa Cruz.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Comodidad garantizada',
				desc: 'La mejor experiencia a bordo con snacks, frazadas y sistema de climatización.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje impreso',
				desc: 'Asegúrate de mostrar tu pasaje impreso al momento de abordar el bus.',
			},
		]
	} else if (operator && operator.operator_name === 'tarapaca') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Amplios asientos',
				desc: `Contamos con buses Salón Cama y Buses Suite Premium 180°.`,
			},
			{
				icon: getIcons('second', operator),
				title: 'Convenios con empresas',
				desc: `Accede a precios
        preferenciales al contratar
        servicios corporativos.`,
			},
			{
				icon: getIcons('third', operator),
				title: 'Viajes de turismo',
				desc: `Cotiza y contrata viajes privados con nosotros.`,
			},
		]
	}
	else if (operator && operator.operator_name === 'buseslafit') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Comodidad a tu medida',
				desc: `Asientos cómodos para un viaje placentero y relajante.`,
			},
			{
				icon: getIcons('second', operator),
				title: 'Tecnología integrada',
				desc: `Buses equipados con tecnología, conexión Wifi y puertos USB.`,
			},
			{
				icon: getIcons('third', operator),
				title: 'Ticket digital',
				desc: `Compra y accede fácilmente a tu ticket desde tu móvil.`,
			},
		]
	}
	else if (operator && operator.operator_name === 'santamaria') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: `Viaja cómodamente eligiendo entre asientos Semi cama o Salón cama.`,
			},
			{
				icon: getIcons('second', operator),
				title: 'Seguridad',
				desc: `Contamos con todas las medidas de seguridad para que disfrutes un viaje tranquilo.`,
			},
			{
				icon: getIcons('third', operator),
				title: 'Ticket móvil',
				desc: `Puedes mostrar tu pasaje digital desde el celular al abordar el bus.`,
			},
		]
	}
	else if (operator && operator.operator_name === 'biaggini') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Viajes interurbanos e interprovinciales',
				desc: `Con una amplia flota y los mejores buses del mercado.`,
			},
			{
				icon: getIcons('second', operator),
				title: 'Traslados privados',
				desc: `Cotiza tus viajes privados. Viaja seguro y cómodo.`,
			},
			{
				icon: getIcons('third', operator),
				title: 'Servicio de encomiendas',
				desc: `Deja tus paquetes en manos expertas.`,
			},
		]
	}


	else if (operator && operator.operator_name === 'lineaazul') {

		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja cómodamente eligiendo entre asientos Semi cama o Salón cama.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Tecnología a bordo',
				desc: 'Aprovecha las comodidades y cargador USB de nuestros buses durante tu viaje.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje digital',
				desc: 'Muestra tu pasaje desde tu celular al momento de abordar el bus.',
			},
		]
	} else if (operator && operator.operator_name === 'santarosa') {

		return [
			{
				icon: getIcons('ist', operator),
				title: 'Seguridad y comodidad',
				desc: 'Confort y descanso en cada trayecto con nuestros asientos. ',
			},
			{
				icon: getIcons('second', operator),
				title: 'Buses Inteligentes',
				desc: 'Equipados con tecnología, conexión Wifi y puertos USB.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Servicio de encomiendas',
				desc: 'La forma más confiable de enviar tus encomiendas.',
			},
		]
	}
	else
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja cómodamente eligiendo entre asientos Semi cama o Salón cama.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Tecnología a bordo',
				desc: 'Aprovecha las comodidades y cargador USB de nuestros buses durante tu viaje.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje impreso',
				desc: 'Asegúrate de mostrar tu pasaje impreso al momento de abordar el bus.',
			},
		];
};

export default ThemeTwoIconsSection;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/ThemeTwoIconsSection.js